import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExsepService } from '../../services/exsep/exsep.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { RejectExsepComponent } from '../../components/reject-exsep/reject-exsep.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormatDate } from '../../utils/date.util';
import { ApplicationStatus } from '../../Enums/application-status.enum';

@Component({
  selector: 'app-service-request-details',
  templateUrl: './service-request-details.component.html',
  styleUrls: ['./service-request-details.component.scss'],
})
export class ServiceRequestDetailsComponent implements OnInit {
  requestId: number | null = null;
  title: string = 'تفاصيل طلب الخدمة';
  requestFormGroup!: FormGroup;
  requestData: any = null;
  isLoading: boolean = false;
  saveDialogRef!: MatDialogRef<AlertBoxComponent>;
  private dialog: MatDialog = inject(MatDialog);
  formatDate = FormatDate;
  ApplicationStatus = ApplicationStatus;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private exsepService: ExsepService,
  ) {}

  ngOnInit(): void {
    const routeParam = this.activatedRoute.snapshot.params['id'];
    if (routeParam) {
      this.requestId = Number(routeParam);
      this.getRequestDetails(this.requestId);
    }

    this.createForm();
    this.titleService.setTitle(this.title + ' | عاين');
  }

  createForm(): void {
    this.requestFormGroup = this.formBuilder.group({
      name: [''],
      submission_date: [''],
      rating: [''],
      specialization: [''],
      requests_count: [''],
      city: [''],
      region: [''],
      service: [''],
      renewal_date: [''],
    });
  }

  getRequestDetails(id: number): void {
    this.isLoading = true;

    this.exsepService.getServiceRequestDetails(id).subscribe({
      next: (data: any) => {
        this.requestData = data?.data;
        this.populateForm(this.requestData);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading request details:', error);
        this.isLoading = false;
      },
    });
  }

  populateForm(data: any): void {
    this.requestFormGroup.patchValue({
      name: data.name,
      submission_date: data.submission_date,
      rating: data.rating,
      specialization: data.specialization,
      requests_count: data.requests_count,
      city: data.city,
      region: data.region,
      service: data.service,
      renewal_date: data.renewal_date,
    });
  }

  onSubmit(): void {
    if (!this.requestId) return;
    this.isLoading = true;
    this.exsepService
      .updateServiceRequestStatus(this.requestId, {
        status: ApplicationStatus.ACCEPTED,
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.showAlertBox('تم الموافقة على الطلب بنجاح'); 
          this.goToList();
        },
        error: (error) => {
          this.isLoading = false;
          this.showAlertBox('حدث خطأ أثناء الموافقة على الطلب');
          console.error(error);
        },
      });
  }

  rejectRequest(): void {
    if (!this.requestId) return;
    this.isLoading = true;
    this.exsepService
      .updateServiceRequestStatus(this.requestId, {
        status: ApplicationStatus.REJECTED,
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.showAlertBox('تم رفض الطلب بنجاح');
          this.goToList();
        },
        error: (error) => {
          this.isLoading = false;
          this.showAlertBox('حدث خطأ أثناء رفض الطلب');
          console.error(error);
        },
      });
  }

  requestModification(): void {
    const dialogRef = this.dialog.open(RejectExsepComponent, {
      width: '600px',
      data: {
        notes: this.requestData?.note,
        title: 'وضح البيانات أو المعلومات الناقصة فى هذا الطلب',
        placeholder: 'اكتب المعلومات الناقصة',
        buttonTxt: 'إرسال الملاحظة',
        buttonColor: 'yellow',
      },
    });
    dialogRef.afterClosed().subscribe((note) => {
      if (note && this.requestId) {
        this.isLoading = true;
        this.exsepService
          .updateServiceRequestStatus(this.requestId, {
            status: ApplicationStatus.REVISION_NEEDED,
            notes: note,
          })
          .subscribe({
            next: () => {
              this.isLoading = false;
              this.showAlertBox('تم طلب التعديل بنجاح');
              this.goToList();
            },
            error: (error) => {
              this.isLoading = false;
              this.showAlertBox('حدث خطأ أثناء طلب التعديل');
              console.error(error);
            },
          });
      }
    });
  }

  goToList(): void {
    this.router.navigate(['/pages/sopra/services-requests']);
  }

  copyClientMobile() {
    if (this.requestData?.phone) {
      const mobileWithoutSpaces = this.requestData.phone.replace(/\s/g, '');
      this.copyLink(mobileWithoutSpaces);
    }
  }

  copyLink(link: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.showAlertBox();
  }

  showAlertBox(message?: string) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: true,
        message: message || 'تم النسخ بنجاح',
        button: 'تم',
      },
    });
  }
}
